// THIS FILE WILL RUN ANY CONFIGURATION THAT WILL LOAD BEFORE RENDER APP
import { Fragment, useEffect } from 'react';
import ReactGA from 'react-ga';
import { connect } from 'react-redux';
import {
  getBookingWidgetConfigByResort,
  getCartConfigByResort,
  getCmpConfigByResort,
  getCreditPackageConfigByResort,
  getDaypassConfigByResort,
  getLeadGenConfigByResort,
  getLoyaltyConfigByResort,
  getPartyBookingWidgetConfigByResort,
  getPaymentConfigByResort,
  getPlanConfigByResort,
  getProfilePageConfigResort,
  resetLodgeConfig
} from '../../store/componentStores/LodgeConfig/lodgeConfig.actions';
import {
  getIsInPrimerState,
  getIsLoyaltyEnabled,
  getMaxOccupancy,
  getReferralEnabledLocation
} from '../../store/componentStores/LodgeConfig/lodgeConfig.selectors';

import { updateCurrentLodge } from '../../store/componentStores/CurrentLodge/currentLodge.actions';
import { getResortLocation } from '../../store/componentStores/CurrentLodge/currentLodge.selectors';

import useCurrentResort from '../../hooks/ui_hooks/useCurrentResort';

import useLocationList from '../../hooks/ui_hooks/useLocationList';
import {
  LODGE_CONFIG_DATA_TTL,
  LODGE_LOCATION_DATA_TTL
} from '../../store/componentStores/utilities/endpointTtlValidation';
import { setLocation } from '../../utilities/analytics';
import { SITE_NIAGON } from '../../utilities/constants';
import duettoTracking from '../../utilities/duetto';
import { Environments } from '../../utilities/env';
import {
  LocalStorageKeys,
  isReferAfriendSessionCreatedAlready,
  sessionStorage_transfer
} from '../../utilities/storageUtils';
import useEndpointValidation from '../utilities/hooks/useEndpointValidation';
import useLodgeApi from '../../hooks/api_hooks/useLodgeApi';

const AppConfiguration = ({
  children,
  getLoyaltyConfigByResort,
  getPlanConfigByResort,
  getDaypassConfigByResort,
  isInPrimerState,
  isLoyaltyEnabled,
  isReferralEnabledLocation,
  getCreditPackageConfigByResort,
  getPaymentConfigByResort,
  getLeadGenConfigByResort,
  getCmpConfigByResort,
  resetLodgeConfig,
  resortLocation,
  updateCurrentLodge,
  getCartConfigByResort,
  getBookingWidgetConfigByResort,
  getPartyBookingWidgetConfigByResort,
  maxOccupancy,
  getProfilePageConfigResort
}) => {
  const { updateResortData } = useCurrentResort();
  const { getLodgesLocations } = useLodgeApi();
  const { locationList, updateLocationList } = useLocationList();

  const fetchAndStoreLocationList = async () => {
    getLodgesLocations({
      callbacks: {
        onSuccess: updateLocationList,
        onFailure: error => {
          throw new Error(`Oops, ${error.message}`);
        }
      }
    });
  };

  const endpointList = [
    {
      name: 'lodgeLocations',
      TTL: LODGE_LOCATION_DATA_TTL,
      call: fetchAndStoreLocationList,
      isLodgeSpecific: false
    },
    {
      name: 'loyaltyConfigByResort',
      TTL: LODGE_CONFIG_DATA_TTL,
      call: getLoyaltyConfigByResort,
      isLodgeSpecific: true
    },
    {
      name: 'planConfigByResort',
      TTL: LODGE_CONFIG_DATA_TTL,
      call: getPlanConfigByResort,
      validateUrl: true,
      isLodgeSpecific: true
    },
    {
      name: 'daypassConfigByResort',
      TTL: LODGE_CONFIG_DATA_TTL,
      call: getDaypassConfigByResort,
      validateUrl: true,
      isLodgeSpecific: true
    },
    {
      name: 'creditPackageConfigByResort',
      TTL: LODGE_CONFIG_DATA_TTL,
      call: getCreditPackageConfigByResort,
      validateUrl: true,
      isLodgeSpecific: true
    },
    {
      name: 'leadGenConfigByResort',
      TTL: LODGE_CONFIG_DATA_TTL,
      call: getLeadGenConfigByResort,
      isLodgeSpecific: true
    },
    {
      name: 'cmpConfigByResort',
      TTL: LODGE_CONFIG_DATA_TTL,
      call: getCmpConfigByResort,
      validateUrl: true,
      isLodgeSpecific: true
    },
    {
      name: 'paymentConfigByResort',
      TTL: LODGE_CONFIG_DATA_TTL,
      call: getPaymentConfigByResort,
      validateUrl: true,
      isLodgeSpecific: true
    },
    {
      name: 'cartConfigByResort',
      TTL: LODGE_CONFIG_DATA_TTL,
      call: getCartConfigByResort,
      isLodgeSpecific: true
    },
    {
      name: 'bookingWidgetConfigByResort',
      TTL: LODGE_CONFIG_DATA_TTL,
      call: getBookingWidgetConfigByResort,
      isLodgeSpecific: true
    },
    {
      name: 'partyBookingWidgetConfigByResort',
      TTL: LODGE_CONFIG_DATA_TTL,
      call: getPartyBookingWidgetConfigByResort,
      validateUrl: true,
      isLodgeSpecific: true
    },
    {
      name: 'profilePageConfigResort',
      TTL: LODGE_CONFIG_DATA_TTL,
      call: getProfilePageConfigResort,
      validateUrl: true,
      isLodgeSpecific: true
    }
  ];

  useEndpointValidation(maxOccupancy, endpointList, resetLodgeConfig, resortLocation);

  useEffect(() => {
    if (!isReferralEnabledLocation) return;
    // Ask other tabs for session storage
    if (!isReferAfriendSessionCreatedAlready()) {
      localStorage.setItem(LocalStorageKeys.GET_SESSION_STORAGE, Date.now());
    }

    // Run transfer
    window.addEventListener('storage', sessionStorage_transfer);

    // Clean events
    return function cleanupListener() {
      window.removeEventListener('storage', sessionStorage_transfer, false);
    };
  }, [isReferralEnabledLocation]);

  useEffect(() => {
    const voyagersClubPhase = !isLoyaltyEnabled ? 'VO' : isInPrimerState ? 'V1' : 'V2';
    ReactGA.set({ dimension58: voyagersClubPhase });
  }, [isInPrimerState, isLoyaltyEnabled]);

  useEffect(() => {
    if (process.env.NODE_ENV === Environments.DEVELOPMENT) return;
    if (resortLocation) {
      duettoTracking.initialize(
        resortLocation === SITE_NIAGON
          ? process.env.REACT_APP_DUETTO_ID_NIAGARA
          : process.env.REACT_APP_DUETTO_ID_UNIVERAL
      );
      setLocation(resortLocation);
    }
  }, [resortLocation]);

  useEffect(() => {
    updateCurrentLodge(locationList);
    updateResortData(locationList);
  }, [locationList, updateCurrentLodge, updateResortData]);

  return resortLocation ? <Fragment>{children}</Fragment> : null;
};

const mapStateToProps = state => ({
  maxOccupancy: getMaxOccupancy(state.lodgeConfig),
  isInPrimerState: getIsInPrimerState(state.lodgeConfig),
  isLoyaltyEnabled: getIsLoyaltyEnabled(state.lodgeConfig),
  isReferralEnabledLocation: getReferralEnabledLocation(state.lodgeConfig),
  resortLocation: getResortLocation(state.currentLodge)
});

const mapDispatchToProps = {
  getLoyaltyConfigByResort,
  getPlanConfigByResort,
  getDaypassConfigByResort,
  getCreditPackageConfigByResort,
  getPaymentConfigByResort,
  getLeadGenConfigByResort,
  getCmpConfigByResort,
  resetLodgeConfig,
  updateCurrentLodge,
  getCartConfigByResort,
  getBookingWidgetConfigByResort,
  getPartyBookingWidgetConfigByResort,
  getProfilePageConfigResort
};

export default connect(mapStateToProps, mapDispatchToProps)(AppConfiguration);
